import Wait from './Wait';
import Log from './Log';

const clearMessageTimeoutInSeconds = 0.25;

const readAlert = async (message: string): Promise<void> => {
   try {
      const ariaLiveStatusElement = document.getElementById('aria-live-status');
      if (ariaLiveStatusElement != null) {
         ariaLiveStatusElement.innerText = message;
         await Wait.seconds(clearMessageTimeoutInSeconds);
         ariaLiveStatusElement.innerText = '';
      }
   } catch (e) {
      Log.info(e);
   }
};

export default {
   readAlert
};